import { connect } from "react-redux";
import { OpenEnded as Component } from "../OpenEnded";
import { oeqAnswer, oeqSubmit } from "./store/actions";

/**
 * mapStateToProps - This function maps the state from the Redux store to the component's props.
 * It allows us to extract specific data from the Redux store state and use them as props within our React component.
 *
 * @param {Object} state - The entire state of the Redux store.
 * @param {Object} props - The current props of the component.
 *
 * @returns {Object} - Returns an object which populates the props of our component.
 */
function mapStateToProps(state, props) {
  // Find the entry in the store state using the provided id.
  const entry = state.oeq[props.id];

  if (!entry) {
    // If no matching entry is found, return the original props.
    return props;
  }

  const answer = entry.answer;
  const renderFeedback = entry.renderFeedback;

  return {
    ...props,
    renderFeedback: renderFeedback,
    answer: answer,
  };
}

/**
 * mapDispatchToProps - Maps dispatch actions to the component's props.
 * This allows our React component to dispatch actions to modify the state in the Redux store.
 *
 * @param {Function} dispatch - The dispatch function from the Redux store.
 *
 * @returns {Object} - Returns an object with dispatch action functions.
 */
function mapDispatchToProps(dispatch) {
  return {
    setAnswer: (params) => {
      dispatch(oeqAnswer(params));
    },
    submitAnswer: (params) => {
      dispatch(oeqSubmit(params));
    },
  };
}

// Connect our component to the Redux store.
// This HOC (Higher Order Component) provides our component with props from the store state (mapStateToProps) and dispatch actions (mapDispatchToProps).
export const OpenEndedRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
